import React from 'react'
import Header from '../components/Header';
import Footer from '../components/Footer';
import Leftsidebarindustry from '../components/Leftsidebarindustry';
import Indusrtypagebanner from '../components/Indusrtypagebanner';


function NBFCs() {
  return (
    <div>
        <Header/>
  <Indusrtypagebanner/>
         <div className="service-details-section sp1">
    <div className="container">
        <div className="row">
            <Leftsidebarindustry/>

            <div className="col-lg-8">
                <div className="service-main-content heading1 padding1">
                    <h3>Non-Banking Financial Companies (NBFCs)</h3>
                    <div className="space16"></div>
                   
                    <div className="space32"></div>
                    <div className="img1">
                        <img src="assets/img/industry/Industry_Focus/Non-Banking_Financial_Companies.png" alt=""/>
                    </div>
                    <div className="space32"></div>
                  
                    <div className="space16"></div>
                     <p>The NBFC sector in India is growing rapidly and demands finance professionals who are not only skilled but also highly adaptable to regulatory changes.</p>
                     <div className="space32"></div>
                    <p>At JBY Talent Acquisition & Management Private Limited, we provide recruitment support for roles like credit risk analysts, loan processors, collection executives, finance managers, and customer service representatives. </p>
                    <div className="space16"></div>
                    <p>Our deep understanding of NBFC operations helps us align the right candidates with the right responsibilities, reducing attrition and boosting productivity.Whether you’re expanding your loan vertical or need experienced professionals in finance and compliance, JBY ensures your hiring is fast, efficient, and future-ready. </p>
                    <div className="space32"></div>
                  
                
                    <div className="space32"></div>
                 
                </div>
            </div>
        </div>
    </div>
</div>
        <Footer/>
      
    </div>
  )
}

export default NBFCs
